module.exports = __webpack_public_path__ + "img/icon-login-eye.b6f213b8.svg";